export default {
  www: 'https://www.sasmango.com/sas/',
  api: 'https://api.sasmango.com/',
  dev: 'https://dev.sasmango.com/',
  io: 'https://io.sasmango.com/',
  leg: 'https://legacy.sasmango.com/',
  client: 'https://cli.sasmango.com/',
  zip: 'https://zipcloud.ibsnet.co.jp/api/search',
  gmap: 'https://maps.google.co.jp/maps/search/'
}
